<div class="text-bg-highlight text-xlarge text-ellipsis">"{{ synonym.synonym }}"</div>
<div class="mt-3 mb-5">
  <p>Synonymiserad till</p>
  <a class="text-large" href="#" onclick="return false">{{ synonym.name }}</a>
</div>
<form [formGroup]="form">
  <div class="d-flex flex-column mb-3">
    <label for="standardnamn">Ändra som synonym till</label>
    <p-select
      id="standardnamn"
      formControlName="selectedStandardNamn"
      styleClass="w-100"
      [options]="standardNamnList"
      optionLabel="standardNamn"
      optionValue="standardNamn"
      placeholder="Välj"
      [filter]="true"
      [virtualScroll]="true"
      [virtualScrollItemSize]="40"
    >
    </p-select>
  </div>
  <div class="d-flex flex-column mb-3">
    <label for="comment">Kommentar</label>
    <textarea id="comment" formControlName="comment" type="text" rows="3" pInputTextarea></textarea>
  </div>
</form>
<div class="d-flex mt-4">
  <button type="button" class="btn btn-secondary flex-grow-1" [style.marginRight]="'20px'" (click)="close()">
    Avbryt
  </button>
  <button type="button" class="btn btn-primary flex-grow-1" (click)="save()" [disabled]="form.pristine || !form.valid">
    Spara
  </button>
</div>
